import {
    BorderedGrid,
    BorderedGridItem,
    ReadonlyFieldLabel,
    ReadonlyFieldValue
} from '@containers/form-i9/styles';
import * as React from 'react';
import { createTranslationService } from '@services/factories';
import { cacheTranslations } from '@utils/cache-translations';
import { observer } from 'mobx-react';

interface IProps {
    store: {
        lastName: string;
        firstName: string;
        middleInitial: string;
        citizenshipStatus: string;
    };
    className?: string;
    style?: React.CSSProperties;
}

enum EmployeeInfoVerificationTranslation {
    employeeInfoFromSection1 = 'employeeInfoFromSection1',
    lastNameLabel = 'lastNameLabel',
    firstNameLabel = 'firstNameLabel',
    middleInitialLabel = 'middleInitialLabel',
    citizenshipImmigrationStatusLabel = 'citizenshipImmigrationStatusLabel'
}

const EmployeeInfoVerification: React.FunctionComponent<IProps> = observer(
    ({
         store,
        className,
        style
    }) => {
        const translations = cacheTranslations(
            createTranslationService(),
            EmployeeInfoVerificationTranslation,
            'employeeInfoVerification'
        );

        return (
            <div className={className}
                 style={style}>
                <BorderedGrid container={true}
                              wrap='wrap'>
                    <BorderedGridItem xs={12} sm={2}>
                        <ReadonlyFieldLabel>{translations.employeeInfoFromSection1}</ReadonlyFieldLabel>
                    </BorderedGridItem>
                    <BorderedGridItem xs={12} sm={3}>
                        <ReadonlyFieldLabel>{translations.lastNameLabel}</ReadonlyFieldLabel>
                        <ReadonlyFieldValue>{store.lastName}</ReadonlyFieldValue>
                    </BorderedGridItem>
                    <BorderedGridItem xs={12} sm={3}>
                        <ReadonlyFieldLabel>{translations.firstNameLabel}</ReadonlyFieldLabel>
                        <ReadonlyFieldValue>{store.firstName}</ReadonlyFieldValue>
                    </BorderedGridItem>
                    <BorderedGridItem xs={2} sm={1}>
                        <ReadonlyFieldLabel>{translations.middleInitialLabel}</ReadonlyFieldLabel>
                        <ReadonlyFieldValue>{store.middleInitial}</ReadonlyFieldValue>
                    </BorderedGridItem>
                    <BorderedGridItem xs={10} sm={3}>
                        <ReadonlyFieldLabel>{translations.citizenshipImmigrationStatusLabel}</ReadonlyFieldLabel>
                        <ReadonlyFieldValue>{store.citizenshipStatus}</ReadonlyFieldValue>
                    </BorderedGridItem>
                </BorderedGrid>
            </div>
        );
    }
);

export default EmployeeInfoVerification;



// WEBPACK FOOTER //
// ./src/containers/form-i9/employee-info-verification.tsx